var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3811 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 3811,
    height: 1080,
    fill: "#3E41B3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1360,
    cy: 121,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1249,
    cy: 199,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1953,
    cy: 431,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 307,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1613,
    cy: 539,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 804,
    cy: 110,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1508,
    cy: 342,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1096,
    cy: 291,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1800,
    cy: 523,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1115,
    cy: 127,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1819,
    cy: 359,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 348,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1264,
    cy: 580,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423,
    cy: 312,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1127,
    cy: 544,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469,
    cy: 141,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1173,
    cy: 373,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 313,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 923,
    cy: 545,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 90,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926,
    cy: 322,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767,
    cy: 408,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471 550C1471 551.657 1469.66 553 1468 553C1466.34 553 1465 551.657 1465 550C1465 548.343 1466.34 547 1468 547C1469.66 547 1471 548.343 1471 550Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 669,
    cy: 104,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1373,
    cy: 336,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1395,
    cy: 263,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1089,
    cy: 673,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411,
    cy: 744,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1246,
    cy: 405,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1524,
    cy: 607,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 236,
    cy: 583,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1117,
    cy: 382,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439,
    cy: 453,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1474,
    cy: 168,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1752,
    cy: 370,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464,
    cy: 346,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1168,
    cy: 578,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 649,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1937,
    cy: 171,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 927,
    cy: 349,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 420,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1517,
    cy: 707,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1647,
    cy: 153,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1925,
    cy: 355,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 637,
    cy: 331,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 952,
    cy: 201,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1656,
    cy: 433,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 579,
    cy: 187,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1283,
    cy: 419,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 262,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048,
    cy: 494,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 471,
    cy: 112,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1175,
    cy: 344,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 282,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 845,
    cy: 514,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 87,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3427,
    cy: 121,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3316,
    cy: 199,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2976,
    cy: 307,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3680,
    cy: 539,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2871,
    cy: 110,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3575,
    cy: 342,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3163,
    cy: 291,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3182,
    cy: 127,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2627,
    cy: 348,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3331,
    cy: 580,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2490,
    cy: 312,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3194,
    cy: 544,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2536,
    cy: 141,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3240,
    cy: 373,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2286,
    cy: 313,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2990,
    cy: 545,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2289,
    cy: 90,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2993,
    cy: 322,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2834,
    cy: 408,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3538 550C3538 551.657 3536.66 553 3535 553C3533.34 553 3532 551.657 3532 550C3532 548.343 3533.34 547 3535 547C3536.66 547 3538 548.343 3538 550Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2736,
    cy: 104,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3440,
    cy: 336,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3462,
    cy: 263,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3156,
    cy: 673,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2478,
    cy: 744,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3313,
    cy: 405,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3591,
    cy: 607,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2303,
    cy: 583,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3184,
    cy: 382,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2506,
    cy: 453,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3541,
    cy: 168,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2531,
    cy: 346,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3235,
    cy: 578,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2557,
    cy: 649,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2994,
    cy: 349,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2316,
    cy: 420,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3584,
    cy: 707,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3714,
    cy: 153,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2704,
    cy: 331,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2026,
    cy: 402,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3019,
    cy: 201,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3723,
    cy: 433,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2646,
    cy: 187,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3350,
    cy: 419,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2411,
    cy: 262,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3115,
    cy: 494,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2538,
    cy: 112,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3242,
    cy: 344,
    r: 3,
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2208,
    cy: 282,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2912,
    cy: 514,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2294,
    cy: 87,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1330.5,
    cy: 256.5,
    r: 87.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1368.5,
    cy: 258,
    rx: 19.5,
    ry: 20,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1288,
    cy: 295.5,
    rx: 8,
    ry: 7.5,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1296,
    cy: 211,
    rx: 15,
    ry: 14,
    fill: "#C4C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1195,
    y: 122,
    width: 273,
    height: 273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 14,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3811,
    height: 1080,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.50c1cdb6.svg";
export { ForwardRef as ReactComponent };